export type Result<Error, Value> = Ok<Value> | Err<Error>

export interface Ok<T> {
    type: 'Ok'
    value: T
}

export interface Err<T> {
    type: 'Err'
    error: T
}

export function map<Error, A, B>(
    fn: (value: A) => B,
    result: Result<Error, A>,
): Result<Error, B> {
    switch (result.type) {
        case 'Ok':
            return {
                type: 'Ok',
                value: fn(result.value),
            }
        case 'Err':
            return result
    }
}

export function mapError<A, B, T>(
    fn: (error: A) => B,
    result: Result<A, T>,
): Result<B, T> {
    switch (result.type) {
        case 'Ok':
            return result
        case 'Err':
            return {
                type: 'Err',
                error: fn(result.error),
            }
    }
}

export function toNullable<Error, Value>(
    result: Result<Error, Value>,
): Value | null {
    switch (result.type) {
        case 'Ok':
            return result.value
        case 'Err':
            return null
    }
}

export function andThen<Error, A, B>(
    fn: (value: A) => Result<Error, B>,
    result: Result<Error, A>,
): Result<Error, B> {
    switch (result.type) {
        case 'Ok':
            return fn(result.value)
        case 'Err':
            return result
    }
}

export function fromError<Error, Value>(
    // tslint:disable-next-line no-any
    extractError: (error: any) => Error,
    fn: () => Value,
): Result<Error, Value> {
    try {
        return {type: 'Ok', value: fn()}
    } catch (error) {
        return {type: 'Err', error: extractError(error)}
    }
}

export function errorToNullable<Error, Value>(
    result: Result<Error, Value>,
): Error | null {
    switch (result.type) {
        case 'Ok':
            return null
        case 'Err':
            return result.error
    }
}

export function compose<A, B, C, E>(
    f: (value: B) => Result<E, C>,
    g: (value: A) => Result<E, B>,
): (value: A) => Result<E, C> {
    return (value: A) => andThen(f, g(value))
}

export function withDefault<Error, Value>(
    defaultValue: Value,
    result: Result<Error, Value>
): Value {
    switch (result.type) {
        case 'Ok':
            return result.value
        case 'Err':
            return defaultValue
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Result.ts